if (document.querySelector(".blog-dropdown__select")) {
  document.addEventListener("DOMContentLoaded", function () {
    document
      .querySelector(".blog-dropdown__select")
      .addEventListener("change", function () {
        const selectedValue = this.value;
        if (selectedValue) {
          window.location.href = selectedValue;
        }
      });
  });
}
